import { ClrInputModule, ClarityModule, ClrIconModule } from '@clr/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, ClrIconModule, ClrInputModule, ClarityModule],
    exports: [ClrIconModule, ClrInputModule, ClarityModule]
})

export class CustomClarityModule{}
